import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Navigate } from "react-router-dom";
import React from "react";

type ProtectedRouteProps = {
    element: React.ComponentType
}

export const ProtectedRoute = ({element: Element}: ProtectedRouteProps) => {
    const { isLoggedIn } = useSelector((state: RootState) => state.loggedIn);

    return isLoggedIn ? <Element /> : <Navigate to="/" replace />
}
